import { createSelector } from "@reduxjs/toolkit";
import { DEFAULT_ACTION_FOR_RESUMING_MODE, DEFAULT_ACTION_FOR_STARTING_MODE, DEFAULT_DETAILED_ALBUM_LIST_PAGE_SIZE, DEFAULT_RANDOM_METHOD, DEFAULT_RANDOM_QUEUE_LENGTH, DEFAULT_SQUARED_ALBUM_LIST_PAGE_SIZE, NOT_SET_VALUE } from "../utils/constants/userSettingsConstants";
import { SET_ACTION_FOR_RESUMING_RANDOM_MODE, SET_ACTION_FOR_STARTING_RANDOM_MODE, SET_ALWAYS_CLEAR_QUEUE, SET_AUTO_NEW_RANDOM_ALBUM, SET_CURRENT_ALBUM_LIST_PAGE_SIZE, SET_DETAILED_ALBUM_LIST_PAGE_SIZE, SET_RANDOM_METHOD, SET_RANDOM_QUEUE_LIMIT, SET_SETTINGS_WINDOW_VISIBLE, SET_SQUARED_ALBUM_LIST_PAGE_SIZE } from "../actions/userSettingsActions";

export const getCurrentAlbumListPageSize = createSelector(
    state => state.userSettingsState.albumListPageSize,
    albumListPageSize => albumListPageSize.currentSize
)

export const getDetailedAlbumListPageSize = createSelector(
    state => state.userSettingsState.albumListPageSize,
    albumListPageSize => albumListPageSize.detailedAlbumSize
);

export const getSquaredAlbumListPageSize = createSelector(
    state => state.userSettingsState.albumListPageSize,
    albumListPageSize => albumListPageSize.squaredAlbumSize
);

export const getRandomMethod = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.randomMethod
);

export const getRandomQueueLimit = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.randomQueueLimit
);

export const getAutoNewRandomAlbum = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.autoNewRandomAlbum
);

export const getAlwaysClearQueue = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.alwaysClearQueue
);

export const getActionForStartingRandomMode = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.actionForStartingRandomMode
);

export const getActionForResumingRandomMode = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.actionForResumingRandomMode
);

export const getUserSettings = createSelector(
    state => state.userSettingsState,
    userSettingsState => ({
        currentAlbumListPageSize: userSettingsState.albumListPageSize.currentSize,
        detailedAlbumListPageSize: userSettingsState.albumListPageSize.detailedAlbumSize,
        squaredAlbumListPageSize: userSettingsState.albumListPageSize.squaredAlbumSize,
        randomMethod: userSettingsState.randomMethod,
        randomQueueLimit: userSettingsState.randomQueueLimit,
        autoNewRandomAlbum: userSettingsState.autoNewRandomAlbum,
        alwaysClearQueue: userSettingsState.alwaysClearQueue,
        actionForStartingRandomMode: userSettingsState.actionForStartingRandomMode,
        actionForResumingRandomMode: userSettingsState.actionForResumingRandomMode
    })
);

export const isSettingsWindowVisible = createSelector(
    state => state.userSettingsState,
    userSettingsState => userSettingsState.settingsWindowVisible
);

const INITIAL_STATE = {
    albumListPageSize: {
        currentSize: DEFAULT_DETAILED_ALBUM_LIST_PAGE_SIZE,
        detailedAlbumSize: DEFAULT_DETAILED_ALBUM_LIST_PAGE_SIZE,
        squaredAlbumSize: DEFAULT_SQUARED_ALBUM_LIST_PAGE_SIZE
    },
    randomMethod: DEFAULT_RANDOM_METHOD,
    randomQueueLimit: DEFAULT_RANDOM_QUEUE_LENGTH,
    autoNewRandomAlbum: true,
    alwaysClearQueue: NOT_SET_VALUE,
    actionForStartingRandomMode: DEFAULT_ACTION_FOR_STARTING_MODE,
    actionForResumingRandomMode: DEFAULT_ACTION_FOR_RESUMING_MODE,
    settingsWindowVisible: false
}

export const userSettingsState = (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_CURRENT_ALBUM_LIST_PAGE_SIZE:
            return {...state, albumListPageSize: { ...state.albumListPageSize, currentSize: action.payload }};
        case SET_DETAILED_ALBUM_LIST_PAGE_SIZE:
            return {...state, albumListPageSize: { ...state.albumListPageSize, detailedAlbumSize: action.payload }};
        case SET_SQUARED_ALBUM_LIST_PAGE_SIZE:
            return {...state, albumListPageSize: { ...state.albumListPageSize, squaredAlbumSize: action.payload }};
        case SET_RANDOM_METHOD:
            return {...state, randomMethod: action.payload};
        case SET_RANDOM_QUEUE_LIMIT:
            return {...state, randomQueueLimit: action.payload};
        case SET_AUTO_NEW_RANDOM_ALBUM:
            return {...state, autoNewRandomAlbum: action.payload};
        case SET_ALWAYS_CLEAR_QUEUE:
            return {...state, alwaysClearQueue: action.payload};
        case SET_ACTION_FOR_STARTING_RANDOM_MODE:
            return {...state, actionForStartingRandomMode: action.payload};
        case SET_ACTION_FOR_RESUMING_RANDOM_MODE:
            return {...state, actionForResumingRandomMode: action.payload};
        case SET_SETTINGS_WINDOW_VISIBLE:
            return {...state, settingsWindowVisible: action.payload};
        default:
            return state;
    }
}